import { RouteObject } from "react-router-dom";
import { EvaluationGroupsList } from "../pages/admin/evaluation-groups/EvaluationGroupsList";
import { EvaluationGroupDetail } from "../pages/admin/evaluation-groups/EvaluationGroupDetail";

export const evaluationGroupsRoutes: RouteObject[] = [
  {
    id: "evaluation-groups-list",
    index: true,
    element: <EvaluationGroupsList />,
  },
  {
    id: "evaluation-group-detail",
    path: ":id",
    element: <EvaluationGroupDetail />,
  },
];
